import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';

/**
 * @type {string}
 */
export const SHOW_SUGGESTIONS_ACTION_TYPE = 'show_suggestions_action_type';

/**
 * @type {string}
 */
export const HIDE_SUGGESTIONS_ACTION_TYPE = 'hide_suggestions_action_type';

/**
 * @type {string}
 */
export const UPDATE_SUGGESTIONS_ACTION_TYPE = 'update_suggestions_action_type';

/**
 * @type {string}
 */
export const IS_FETCHING_SUGGESTIONS_ACTION_TYPE = 'is_fetching_suggestions_action_type';


class SearchReduceStore extends ReduceStore {
    /**
     *
     * @returns {{suggestions: {}, showSuggestions: boolean, isFetching: boolean}}
     */
    getInitialState() {
        return {
            suggestions: {},
            showSuggestions: false,
            isFetching: false,
        };
    }

    /**
     * @param state
     * @param action
     * @returns {*}
     */
    reduce(state = {}, action = {}) {
        switch (action.type) {
        case SHOW_SUGGESTIONS_ACTION_TYPE:
            return {
                ...state,
                showSuggestions: true,
            };
        case HIDE_SUGGESTIONS_ACTION_TYPE:
            return {
                ...state,
                showSuggestions: false,
            };
        case UPDATE_SUGGESTIONS_ACTION_TYPE:
            return {
                ...state,
                suggestions: action.payload,
                showSuggestions: shouldShowSuggestions(action.payload),
            };
        case IS_FETCHING_SUGGESTIONS_ACTION_TYPE:
            return {
                ...state,
                isFetching: action.payload,
            };
        default:
            return state;
        }
    }
}

function shouldShowSuggestions(suggestions) {
    if (!suggestions) {
        return false;
    }

    for (const type in suggestions) {
        if (suggestions.hasOwnProperty(type)) {
            if (suggestions[type].length) {
                return true;
            }
        }
    }

    return false;
}

const SearchStore = new SearchReduceStore(Dispatcher);
export default SearchStore;
